<script>
import Select from "../Components/Select.vue";
import DatePicker from "../Components/DatePicker.vue";
import Travelers from "../Components/HotelTravelers.vue";
import { checkDateDiff } from "../../../Helpers/tools";
import {
  iranNationality,
  hotelLocationType,
  hotelDestinationType,
} from "../../../Constants";
import { hotelLocationMapper } from "../../../Mappers";

export default {
  components: {
    Select,
    DatePicker,
    Travelers,
  },

  data() {
    return {
      locationSearchUrl: null,
      defaultParams: {
        destinationType: hotelDestinationType.internalHotel.value,
      },
      submitData: {
        destination: null,
        departureDate: null,
        returnDate: null,
        nationality: iranNationality,
        rooms: null,
      },
      destinationDefaultList: [],
      isDestinationLandingPage: false,
      isHotelDetailPage: false,
      isLoading: false,
    };
  },

  computed: {
    isFormValid() {
      return Object.values(this.$refs).every((ref) => ref?.isValid);
    },

    dateDiff() {
      return this.submitData.departureDate && this.submitData.returnDate
        ? checkDateDiff({
          firstDate: this.submitData.returnDate,
          secondDate: this.submitData.departureDate,
        })
        : null;
    },
  },

  methods: {
    hotelLocationMapper,

    handleChangeDepartureDate() {
      if (this.dateDiff < 0) {
        this.$refs.returnDate.handleResetValue();
      }
    },

    fillNextInput(type) {
      const inputOrder = [
        "destination",
        "departureDate",
        "returnDate",
        "nationality",
      ];

      const nextInput = inputOrder.find((input) => !this.submitData[input]);

      if (nextInput) {
        this.$refs[nextInput]?.handleOpen();
      }
    },

    validateAllInputs() {
      Object.values(this.$refs).forEach((ref) => ref?.validate());
    },

    buildSearchUrl() {
      const { destination, departureDate, returnDate, rooms, nationality } =
        this.submitData;
      const { hotelSearchUrl } = window.bookingSectionInitialize;

      let searchUrl = hotelSearchUrl;

      if (destination.locationType === hotelLocationType.city.value) {
        searchUrl += `${destination.countrySlug}/${destination.citySlug}/`;
      } else if (destination.locationType === hotelLocationType.hotel.value) {
        searchUrl += `${destination.countrySlug}/${destination.citySlug}/${destination.slug}/`;
      }

      searchUrl += `?&d=${destination.id}&lt=${destination.locationType}&dt=${destination.destinationType}&i=${departureDate}&o=${returnDate}&n=${nationality.countryCode}&r=${rooms.length}`;

      rooms.forEach((room) => {
        searchUrl += `&a=${room.adults}&c=${room.children?.length}`;
        room.children.forEach((child) => {
          searchUrl += `&g=${child.value}`;
        });
      });

      return searchUrl;
    },

    async handleSearch() {
      this.validateAllInputs();

      if (this.isFormValid) {
        this.isLoading = true;
        try {
          const searchUrl = this.buildSearchUrl();
          await window.location.assign(searchUrl);
        } catch (error) {
          console.error("Error during search:", error);
        } finally {
          this.isLoading = false
        }
      }
    },
    checkIsDestinationLandingPage() {
      this.isDestinationLandingPage =
        window?.searchInitialize?.search?.isDestinationLandingPage;
    },
  },

  created() {
    this.isLoading = false;
    this.isHotelDetailPage = Boolean(window.searchInitialize?.hotel);
    this.checkIsDestinationLandingPage();

    if (window.internalHotelList?.length) {
      this.destinationDefaultList = this.hotelLocationMapper({
        model: window.internalHotelList,
      });
    }
    this.locationSearchUrl =
      window.bookingSectionInitialize.hotelLocationSearchUrl;
    window.focusDepartureDateDatePickerInput = () => {
      this.$refs.departureDate.focusInput();
    };
    const destinations = window.searchInitialize?.search?.destinations;
    if (destinations) {
      if (this.isHotelDetailPage) {
        this.submitData.destination = {
          id: destinations.cityId,
          locationType: hotelLocationType.city.value,
          destinationType: destinations.destinationType,
          countrySlug: destinations.countrySlug,
          citySlug: destinations.citySlug,
          title: destinations.cityTitle,
        };
      }
      else {
        this.submitData.destination = {
          ...destinations,
          locationType: destinations.locationType ?? hotelLocationType.city.value,
        };
      }
    }
  },



  unmounted() {
    this.isLoading = false;
    delete window.focusDepartureDateDatePickerInput;
  },
};
</script>

<template>
  <div class="booking__main--hotel">
    <label v-if="!isDestinationLandingPage" class="booking__main--label">انتخاب تاریخ و مشاهده قیمت‌ها</label>
    <div class="booking__row booking__row--no-border">
      <div class="booking__items booking__items--hotel">
        <!-- <div class="booking__date"> -->
        <!-- night duration label inside the end date -->
        <div class="booking__location booking__location--xl booking__location--border" v-if="!isHotelDetailPage">
          <Select label="مقصد" placeholder="انتخاب مقصد" name="destination" v-model="submitData.destination"
            :mapper="hotelLocationMapper" :default-list="destinationDefaultList" :get-data-url="locationSearchUrl"
            :default-params="defaultParams" item-title="title" item-value="id" item-icon="icon"
            @fill-next-input="() => fillNextInput('destination')" ref="destination" list-header="شهرهای پرطرفدار" />
        </div>
        <DatePicker class="booking__items--border js-hotel-check-in-date" label="تاریخ ورود"
          placeholder="انتخاب تاریخ ورود" v-model="submitData.departureDate"
          :on-change-value="handleChangeDepartureDate" @fill-next-input="() => fillNextInput('departureDate')"
          ref="departureDate" name="departureDate" :focusDatePickerInput="true" />
        <!-- end date -->
        <DatePicker class="booking__items--border" label="تاریخ خروج" placeholder="انتخاب تاریخ خروج"
          v-model="submitData.returnDate" :min-date="submitData.departureDate"
          @fill-next-input="() => fillNextInput('returnDate')" ref="returnDate" name="returnDate" />
        <!-- </div> -->
        <!-- travelers -->
        <div class="booking__travelers booking__travelers--border">
          <Travelers v-model="submitData.rooms" ref="rooms" />
        </div>
      </div>
      <!-- search button -->
      <button @click="handleSearch" class="booking__submit btn btn-red" title="جستجو" :disabled="isLoading">
        <span v-if="isLoading" class="bounce-loading bounce-loading--white">
          <span class="bounce1" />
          <span class="bounce2" />
          <span class="bounce3" />
        </span>

        <template v-else>
          <i class="icon-search ml--1" />

          <span>جستجو</span>
        </template>
      </button>
    </div>
  </div>
</template>
